// Soft launch: the join-team requests page only shows for these users while
// the flow is validated with the team leads. Kept in its own module so the
// eagerly-loaded HeaderMenu/App don't pull the lazy page chunk in. Remove the
// gate (or move it to a backend flag) to open the feature to everyone.
export const JOIN_TEAM_ALLOWED_USER_IDS = [
  "63da8a99cc73360030349b1d",
  "63da85cd99898b0030422e1b",
  "63d7d91e6c32775c16a07d4b",
];
